import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import Checkbox from 'common/components/atoms/Checkbox';
import { Td, Tr } from 'common/components/organisms/DataTable';
import { ColumnCell, EditableValue, LockedHint } from './MachineCsv.styled';

function ColumnTableRow({
  columnKey, label, csvHeader, checked, locked, lockedHint, editable, editableLabel, onToggle
}) {
  const handleChange = useCallback(() => onToggle(columnKey), [onToggle, columnKey]);
  return (
    <Tr>
      <Td>
        <ColumnCell>
          <Checkbox
            id={`csv-column-${columnKey}`}
            value={checked}
            disabled={locked}
            onChange={handleChange}
            title={label}
          />
          {csvHeader && csvHeader !== label && <LockedHint>({csvHeader})</LockedHint>}
          {lockedHint && <LockedHint>{lockedHint}</LockedHint>}
        </ColumnCell>
      </Td>
      <Td><EditableValue editable={editable}>{editableLabel}</EditableValue></Td>
    </Tr>
  );
}

ColumnTableRow.propTypes = {
  columnKey: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  csvHeader: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  locked: PropTypes.bool,
  lockedHint: PropTypes.string,
  editable: PropTypes.bool.isRequired,
  editableLabel: PropTypes.string.isRequired,
  onToggle: PropTypes.func.isRequired
};

ColumnTableRow.defaultProps = {
  csvHeader: null,
  locked: false,
  lockedHint: null
};

export default ColumnTableRow;
